import React, { Component } from "react"
import { locale, SharedContext } from "@albelli/photoselector"

interface Props {
  expanded: boolean
  addFiles: (fileList: File[]) => void
  maxFileSize: string
}

export default class UploadForm extends Component<Props, any> {
  static contextType = SharedContext
  constructor(props: Props) {
    super(props)
  }

  handleFileInputChange(e: React.SyntheticEvent) {
    const fileList: File[] = []
    if (e != null && e.target != null) {
      const target = e.target as HTMLInputElement
      if (target != null && target.files != null) {
        for (let i = 0; i < target.files.length; i++) {
          fileList.push(target.files[i])
        }
        this.props.addFiles(fileList)
      }
    }
  }

  /**
   * Drop file handler
   * @param {event} ev
   */
  dropHandler(ev) {
    const fileList: File[] = []
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault()
    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === "file") {
          const file = ev.dataTransfer.items[i].getAsFile()
          fileList.push(file)
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.files.length; i++) {
        fileList.push(ev.dataTransfer.files[i])
      }
    }
    // Pass event to removeDragData for cleanup
    this.removeDragData(ev)

    this.props.addFiles(fileList)
  }

  /**
   * Drag event handler
   * @param {event} ev
   */
  dragOverHandler(ev) {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault()
  }

  /**
   * Remove drag data
   * @param {event} ev
   */
  removeDragData(ev) {
    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to remove the drag data
      ev.dataTransfer.items.clear()
    } else {
      // Use DataTransfer interface to remove the drag data
      ev.dataTransfer.clearData()
    }
  }

  render() {
    const { completeOnSelect } = this.context
    return (
      <div
        className="photoselector-mydevice-wrapper"
        style={{ height: this.props.expanded ? "100%" : "140px", paddingTop: this.props.expanded ? "40px" : "20px" }}
        id="drop_zone"
        data-tam="drop-zone"
        onDrop={(e: React.SyntheticEvent) => this.dropHandler(e)}
        onDragOver={(e: React.SyntheticEvent) => this.dragOverHandler(e)}
      >
        <div className="photoselector-mydevice-wrapper-form">
          <label className={this.props.expanded ? "photoselector-button" : "photoselector-button-small"}>
            <input
              id="file-input"
              data-tam="browse-photos"
              type="file"
              multiple={!completeOnSelect}
              accept={navigator.userAgent.includes("wv") ? "" : "image/png, image/jpeg"}
              onChange={this.handleFileInputChange.bind(this)}
            />
            {locale.get().upload.browseButton}
          </label>
          <div className="text">{locale.get().upload.dragImage + " " + locale.get().upload.uploadlimit(this.props.maxFileSize)}</div>
        </div>
      </div>
    )
  }
}
